<template>
	<div class="">
		<Modal
			v-model="editListModal"
            width="600"
            :title="editTitle"
            :mask-closable="false"
            :loading="loading"
            @on-ok="editList('editListForm')"
        >
			<Form
				ref="editListForm"
				:model="editListForm"
				:rules="ruleValidate"
				:label-width="120"
				label-position="left"
			>
				<FormItem label="联系人姓名"
					prop="contactName"
					label-for="contactName"
				>
				  <Input
				  	placeholder="请输入姓名"
				  	element-id="contactName"
				  	v-model="editListForm.contactName"
				  >
				  	
				  </Input>	
				</FormItem>
				<FormItem label="联系电话"
					prop="contactPhone"
					label-for="contactPhone"
				>
				  <Input
				  	placeholder="请输入电话"
				  	element-id="contactPhone"
				  	v-model="editListForm.contactPhone"
				  >
				  	
				  </Input>	
				</FormItem>
			</Form>
		</Modal>
	</div>
</template>

<script>
export default {
  props: {
    agentId: {
      type: Number
    },
    editTitle: {
      type: String
    },
    editModal: {
      type: Boolean,
      required: true
    },
    editRow: {
      type: Object
    }
  },
  data () {
    const validateMobile = (rule, value, callback) => {
      if (!value.match(/[0-9-()（）]{7,15}/)) {
        callback(new Error('请输入正确的联系电话类型'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      visible: false,
      editListModal: this.editModal,
      editListForm: {
        epId: '',
        contactName: '',
        contactPhone: ''
      },
      ruleValidate: {
        contactName: [
        { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactPhone: [
        { required: true, message: '请输入联系人电话', trigger: 'blur' },
        { validator: validateMobile, trigger: 'blur' },
          { max: 13, message: '请正确的联系电话', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
   // 保存编辑数据
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            epId: this.editRow.id,
            link_person: this.editListForm.contactName,
            link_msisdn: this.editListForm.contactPhone
          }
          let url = '/enterprise/mgr/updateLinkInfo'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              let msg = '编辑成功'
              this.$Message.success(msg)
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.agentId = this.editRow.id
      this.editListForm.epId = this.editRow.id
      this.editListForm.contactName = this.editRow.link_person
      this.editListForm.contactPhone = this.editRow.link_msisdn
    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/EditContact.vue